//for now just call operation notify to see what happens

import { batch } from 'react-redux';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { NoEffectiveReturnPolicy } from 'src/common/helpers/error-code';
import { store } from 'src/common/redux/configure-store';
import { MiddleAreaActions } from 'src/common/redux/reducers/middle-area-reducer';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { updateScannerCallback } from 'src/devices/scanner-operations';
import { applyTbrItemsResponse } from 'src/home-page/business-logic/common/apply-cart-response';
import { onAddItemDataScanned } from 'src/home-page/business-logic/submit-scanned-data';
import { initiateTransaction } from 'src/items-list/business-logic/initiate-transaction';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import {
  handleTransactionSearch,
  nonReceiptReturnOptionModal,
} from 'src/transaction-search/business-logic/handle-transaction-search';
import { getEffectiveReturnPolicy } from 'src/transaction-search/business-logic/service/get-effective-return-policy';
import {
  ReturnPolicyResponse,
  ReturnsType,
} from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { operationNotify } from 'src/operation-notify/operation-notify';
import { CustomerDetailsInfo } from '../interfaces';
import { handleCustomerCapture } from './helper/customer-capture-helper';
import { returnPolicyLookup } from './service/return-policy-lookup';
import { ActivityType } from 'src/operation-notify/enum/activities.enum';
import {
  ITransactionSearchState,
  TransactionSearchContext,
} from 'src/common/interfaces/states/ITransactionSearchState';
import { TransactionSearchActions } from 'src/common/redux/reducers/transaction-search-reducer';

const CustomerDetailsForReturnAreInvalid = 'CustomerDetailsForReturnAreInvalid';

export const returnTransactionClick = (): Promise<void> =>
  startReturnTypeTransaction(ReturnsType.NonReceiptReturn)
    .then(() => {
      updateScannerCallback(onAddItemDataScanned);
    })
    .catch(popupMessage);

export const transactionBasedReturnClick = (): Promise<void> => {
  const searchParam: ITransactionSearchState = {
    dateRange: {
      startDate: new Date(),
      endDate: new Date(),
    },
    searchContext: TransactionSearchContext.TBR,
  };
  store.dispatch(TransactionSearchActions.setSearchParam(searchParam));
  return getTBRReturnPolicy()
    .then(handleTransactionSearch)
    .catch(popupMessage);
};

const getActivityTypeFromReturnType = (returnType: ReturnsType): ActivityType => {
  switch (returnType) {
    case ReturnsType.NonReceiptReturn:
      return ActivityType.ReturnTransaction;
    case ReturnsType.TransactionBasedReturn:
      return ActivityType.TransactionBasedReturn;
    case ReturnsType.BottleDepositReturn:
      return ActivityType.BottleDepositReturn;
    default:
      return ActivityType.ReturnTransaction;
  }
};

export const startReturnTypeTransaction = async (
  returnType: ReturnsType,
  customerDetails?: CustomerDetailsInfo,
  tlogId?: string,
): Promise<void> => {
  const activityType = getActivityTypeFromReturnType(returnType);
  await withSpinner(async () => {
    try {
      if (!customerDetails) {
        await operationNotify(activityType);
      }
      await initiateTransaction({
        typeCode: activityType,
        customerDetails,
        tLogId: tlogId,
      }).then(cartResponse => {
        batch(() => {
          store.dispatch(POSModeActions.setReturnState(returnType));
          if (returnType === ReturnsType.TransactionBasedReturn) {
            applyTbrItemsResponse(cartResponse);
            store.dispatch(POSModeActions.setReturnState(ReturnsType.TransactionBasedReturn));
          }
          store.dispatch(MiddleAreaActions.showActionWindow());
        });
      });
    } catch (err) {
      if (err.code === CustomerDetailsForReturnAreInvalid) {
        const { policyId } = err.data;
        return returnPolicyLookup(policyId).then(response =>
          handleCustomerCapture(returnType, response.customerDetailsFields, tlogId),
        );
      } else {
        throw err;
      }
    }
  });
};

export const exitReturnMode = () => {
  store.dispatch(POSModeActions.setReturnState(undefined, true));
};

export const getTBRReturnPolicy = (): Promise<ReturnPolicyResponse> =>
  getEffectiveReturnPolicy(ReturnsType.TransactionBasedReturn).then(response => {
    if (!response?.receiptLookupPeriod) {
      throw nonReceiptReturnOptionModal(NoEffectiveReturnPolicy);
    }
    return response;
  });
